import { GCP_BUCKET_URL_AVATARS } from "../constants/data";

const ensureMaster = (k) => (/_master$/i.test(k) ? k : `${k}_master`);

export const updateDataAds = (dataAds) => {
  return dataAds.map((ad) => {
    const resolvedImageUrl =
      ad.imageUrl ||
      (ad.imageObjectKey
        ? `${GCP_BUCKET_URL_AVATARS}${ensureMaster(
            String(ad.imageObjectKey).replace(/^\/+/, ""),
          )}`
        : null);

    return {
      id: ad.id,
      imageUrl: resolvedImageUrl,
      imageObjectKey: ad.imageObjectKey,
      name: ad.name,
      status: ad.status,
      governingBodies: ad.governingBodies,
      startDate: ad.startDate,
      endDate: ad.endDate,
      creationDate: ad.creationDate,
    };
  });
};
